const QnaReport = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='16' fill='#FFF3BF' />
      <g clipPath='url(#clip0_3394_52609)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.8571 8H10.8571C10.4025 8 9.96641 8.18061 9.64493 8.5021C9.32344 8.82359 9.14282 9.25963 9.14282 9.71429V22.2857C9.14282 22.7403 9.32344 23.1765 9.64493 23.4979C9.96641 23.8194 10.4024 24 10.8571 24H21.1428C21.5975 24 22.0336 23.8194 22.3551 23.4979C22.6765 23.1765 22.8571 22.7403 22.8571 22.2857V15H16.5714C16.1769 15 15.8571 14.6802 15.8571 14.2857V8ZM22.3795 13.5714L17.2857 8.47759V13.5714H22.3795Z'
          fill='#FA5252'
        />
      </g>
      <defs>
        <clipPath id='clip0_3394_52609'>
          <rect width='16' height='16' fill='white' transform='translate(8 8)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QnaReport;
